class MobileNavigation {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
    this.handleCartUpdates();
    this.setupAccessibility();
  }

  bindEvents() {
    const categoriesToggle  = document.querySelector('[data-categories-toggle]');
    const categoriesOverlay = document.querySelector('[data-categories-overlay]');
    const categoriesBackdrop = document.querySelector('[data-categories-backdrop]');
    const categoriesClose   = document.querySelector('[data-categories-close]');

    if (categoriesToggle && categoriesOverlay) {
      categoriesToggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleCategoriesOverlay();
      });
    }

    if (categoriesClose) {
      categoriesClose.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.closeCategoriesOverlay();
      });
    }

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => this.handleResize(), 100);
    });

    window.addEventListener('orientationchange', () => {
      setTimeout(() => {
        this.ensureButtonClickability();
        this.updateNavigationVisibility();
      }, 200);
    });
  }

  toggleCategoriesOverlay() {
    const overlay = document.querySelector('[data-categories-overlay]');
    if (!overlay) return;
    overlay.classList.contains('is-open')
      ? this.closeCategoriesOverlay()
      : this.openCategoriesOverlay();
  }

  openCategoriesOverlay() {
    const overlay = document.querySelector('[data-categories-overlay]');
    if (!overlay) return;

    /* Measure the full header group bottom (announcement bar + sticky header).
       querySelectorAll used because some selectors may match multiple elements. */
    let topOffset = 0;
    [
      '.shopify-section-group-header-group',
      '#shopify-section-header',
      '.announcement-bar-section',
      '.shopify-section-header',
      'sticky-header',
      '.header-wrapper',
      'header[role="banner"]',
      'header'
    ].forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        const b = el.getBoundingClientRect().bottom;
        /* Ignore anything below the midpoint — prevents picking up page content */
        if (b > topOffset && b < window.innerHeight * 0.45) topOffset = b;
      });
    });

    const content  = overlay.querySelector('.categories-overlay__content');
    const backdrop = overlay.querySelector('.categories-overlay__backdrop');
    if (content)  { content.style.top  = topOffset + 'px'; content.scrollTop = 0; }
    if (backdrop)   backdrop.style.top  = topOffset + 'px';

    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    if (scrollbarWidth > 0) document.body.style.paddingRight = scrollbarWidth + 'px';
    overlay.classList.add('is-open');
    const toggle = document.querySelector('[data-categories-toggle]');
    if (toggle) toggle.classList.add('is-active');
  }

  closeCategoriesOverlay() {
    const overlay = document.querySelector('[data-categories-overlay]');
    if (!overlay || !overlay.classList.contains('is-open')) return;
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    overlay.classList.remove('is-open');
    const categoriesToggle = document.querySelector('[data-categories-toggle]');
    if (categoriesToggle) {
      categoriesToggle.classList.remove('is-active');
      categoriesToggle.focus();
    }
  }

  setPageActiveItem() {
    const path = window.location.pathname;
    document.querySelectorAll('.mobile-nav__item[href]').forEach(item => {
      const rawHref = item.getAttribute('href') || '';
      let hrefPath;
      try { hrefPath = new URL(rawHref, window.location.origin).pathname; }
      catch (_) { hrefPath = rawHref.split('?')[0]; }

      let active = false;
      if (hrefPath === '/') {
        active = path === '/';
      } else if (hrefPath === '/account') {
        // Active on all account sub-pages except login (login is also used for wishlist redirect)
        active = path.startsWith('/account') && path !== '/account/login';
      } else {
        active = path === hrefPath;
      }
      if (active) item.classList.add('is-active');
    });
  }

  handleCartUpdates() {
    document.addEventListener('cart:updated', (event) => {
      const count = event.detail?.cartData?.item_count || event.detail?.itemCount || 0;
      this.updateCartBadge(count);
    });

    document.addEventListener('cart:count-updated', (event) => {
      this.updateCartBadge(event.detail?.count || 0);
    });

    if (window.subscribe && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (event) => {
        this.updateCartBadge(event.cartData?.item_count || 0);
      });
    }

    document.addEventListener('cart:changed', (event) => {
      this.updateCartBadge(event.detail?.item_count || 0);
    });

    document.addEventListener('cart:refresh', () => this.refreshCartCount());

    document.addEventListener('wishlist:updated', (event) => {
      MobileNavUtils.updateWishlistBadge(event.detail?.count || 0);
    });

    this.initializeCartCount();
    this.initializeWishlistCount();
  }

  initializeCartCount() {
    if (window.cartIconManager) {
      const count = window.cartIconManager.getCurrentCount();
      if (count >= 0) { this.updateCartBadge(count); return; }
    }
    if (window.cartManager) {
      this.updateCartBadge(window.cartManager.getItemCount());
      return;
    }
    this.refreshCartCount();
  }

  async refreshCartCount() {
    try {
      const count = await MobileNavUtils.getCartCount();
      this.updateCartBadge(count);
    } catch (_) {}
  }

  initializeWishlistCount() {
    if (window.WishlistSystem?.initialized) {
      MobileNavUtils.updateWishlistBadge(window.WishlistSystem.getWishlistCount());
    } else {
      document.addEventListener('wishlist:ready', () => {
        if (window.WishlistSystem) {
          MobileNavUtils.updateWishlistBadge(window.WishlistSystem.getWishlistCount());
        }
      });
      setTimeout(() => {
        if (window.WishlistSystem?.initialized) {
          MobileNavUtils.updateWishlistBadge(window.WishlistSystem.getWishlistCount());
        }
      }, 1000);
    }
  }

  updateCartBadge(count) {
    const cartItem = document.querySelector('.mobile-nav__item[data-cart-icon]');
    if (!cartItem) return;

    let badge = cartItem.querySelector('.mobile-nav__badge[data-cart-count]');

    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'mobile-nav__badge';
        badge.setAttribute('data-cart-count', count);
        cartItem.querySelector('.mobile-nav__icon').appendChild(badge);
      }
      badge.textContent = count > 99 ? '99+' : count.toString();
      badge.style.display = 'flex';
      badge.setAttribute('data-cart-count', count);
      badge.classList.add('cart-badge-updating');
      setTimeout(() => badge.classList.remove('cart-badge-updating'), 300);
    } else if (badge) {
      badge.style.display = 'none';
      badge.setAttribute('data-cart-count', '0');
    }
  }

  handleResize() {
    if (window.innerWidth > 749) this.closeCategoriesOverlay();
    this.ensureButtonClickability();
    this.updateNavigationVisibility();
  }

  ensureButtonClickability() {
    document.querySelectorAll('.mobile-nav__item, .category-button').forEach(el => {
      el.style.pointerEvents = 'auto';
      el.style.touchAction = 'manipulation';
    });
  }

  updateNavigationVisibility() {
    const mobileNav = document.querySelector('.mobile-nav');
    if (!mobileNav) return;
    mobileNav.style.display = window.innerWidth <= 749 ? 'block' : 'none';
    if (window.innerWidth > 749) this.closeCategoriesOverlay();
  }

  setupAccessibility() {
    const categoriesToggle  = document.querySelector('[data-categories-toggle]');
    const categoriesOverlay = document.querySelector('[data-categories-overlay]');

    if (categoriesToggle && categoriesOverlay) {
      categoriesToggle.setAttribute('aria-expanded', 'false');
      categoriesToggle.setAttribute('aria-controls', 'categories-overlay');
      categoriesOverlay.setAttribute('id', 'categories-overlay');
      categoriesOverlay.setAttribute('role', 'dialog');
      categoriesOverlay.setAttribute('aria-modal', 'true');

      new MutationObserver(() => {
        categoriesToggle.setAttribute(
          'aria-expanded',
          categoriesOverlay.classList.contains('is-open').toString()
        );
      }).observe(categoriesOverlay, { attributes: true });
    }
  }

  /* Public API */
  openCategories()  { this.openCategoriesOverlay(); }
  closeCategories() { this.closeCategoriesOverlay(); }
  refreshCart()     { this.refreshCartCount(); }
  setCartCount(n)   { this.updateCartBadge(n); }
}

const MobileNavUtils = {
  isMobile() {
    return window.innerWidth <= 749;
  },

  async getCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      return cart.item_count || 0;
    } catch (_) {
      return 0;
    }
  },

  updateWishlistBadge(count) {
    const wishlistItem = document.querySelector('.mobile-wishlist-btn');
    if (!wishlistItem) return;

    const iconContainer = wishlistItem.querySelector('.mobile-nav__icon');
    if (!iconContainer) return;

    let badge = iconContainer.querySelector('.mobile-nav__badge.wishlist-count');

    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'mobile-nav__badge wishlist-count';
        iconContainer.appendChild(badge);
      }
      badge.textContent = count > 99 ? '99+' : count.toString();
      badge.style.display = 'flex';
      badge.setAttribute('data-wishlist-count', count);
    } else if (badge) {
      badge.style.display = 'none';
      badge.setAttribute('data-wishlist-count', '0');
    }
  }
};

document.addEventListener('DOMContentLoaded', () => {
  /* Remove any duplicate wishlist badges before initialising */
  const wishlistItem = document.querySelector('.mobile-wishlist-btn');
  if (wishlistItem) {
    const iconContainer = wishlistItem.querySelector('.mobile-nav__icon');
    if (iconContainer) {
      const badges = iconContainer.querySelectorAll('.mobile-nav__badge.wishlist-count');
      for (let i = 1; i < badges.length; i++) badges[i].remove();
    }
  }

  window.mobileNavigation = new MobileNavigation();
  window.mobileNavigation.updateNavigationVisibility();
  window.mobileNavigation.ensureButtonClickability();
  window.mobileNavigation.setPageActiveItem();

  if (window.cartIconManager) {
    setTimeout(() => window.cartIconManager.refresh(), 100);
  }

  setTimeout(() => {
    if (window.mobileNavigation) window.mobileNavigation.refreshCartCount();
  }, 500);
});

window.addEventListener('resize', () => {
  if (!window.mobileNavigation) {
    window.mobileNavigation = new MobileNavigation();
  } else {
    window.mobileNavigation.ensureButtonClickability();
    window.mobileNavigation.updateNavigationVisibility();
  }
});
